import { useState, useEffect } from 'react';
import { TextInput } from 'components/base/TextInput';
import { RoundSmolButton } from 'components/base/RoundSmolButton';
import { GlobeIcon } from 'components/base/GlobeIcon';
import { BulbIcon } from 'components/base/BulbIcon';
import './WordInputRow.css';

const WordInputRow = ({ value, callbackOnChange, callbackOnKeyDown, placeholder, loading, translationEnabled, onToggleTranslation, suggestionsOpen, onToggleSuggestions, maxLength }) => {
  const [count, setCount] = useState(1);

  useEffect(() => {
    if (!loading) return;
    const interval = setInterval(() => {
      setCount((prev) => (prev % 3) + 1);
    }, 400);
    return () => clearInterval(interval);
  }, [loading]);

  if (loading) {
    return (
      <div className="word-input-container">
        <div className="word-input word-input-loading">
          {Array.from({ length: count }).map((_, i) => (
            <img key={i} src="/lexiSpinner.png" alt="" className="word-input-spinner" />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="word-input-container">
      {onToggleSuggestions && (
        <div className="word-input-side-button word-input-side-button--left">
          <RoundSmolButton
            onClick={onToggleSuggestions}
            enabled={suggestionsOpen}
            disabled={!translationEnabled}
            title={suggestionsOpen ? 'Close suggestions' : 'Open suggestions'}
          >
            <BulbIcon />
          </RoundSmolButton>
        </div>
      )}
      <TextInput
        value={value}
        callbackOnChange={callbackOnChange}
        callbackOnKeyDown={callbackOnKeyDown}
        placeholder={placeholder}
        maxLength={maxLength}
      />
      {onToggleTranslation && (
        <div className="word-input-side-button word-input-side-button--right">
          <RoundSmolButton
            onClick={onToggleTranslation}
            enabled={translationEnabled}
            title={translationEnabled ? 'Disable translation' : 'Enable translation'}
          >
            <GlobeIcon />
          </RoundSmolButton>
        </div>
      )}
    </div>
  );
};

export { WordInputRow };
